import { FrontSide, TextureLoader, MeshStandardMaterial, sRGBEncoding } from 'three';

const textureLoader = new TextureLoader();
const texture = textureLoader.load(require('../assets/2D/texture.png'));
texture.encoding = sRGBEncoding;
texture.flipY = false;

export const frontBasicMaterial = new MeshStandardMaterial({ map: texture, side: FrontSide });